export const months = ['January','February','March','April','May','June','July','August', 'September','October','November','December']
export const monthInNumber = [1,2,3,4,5,6,7,8,9,10,11,12]
export const Slots = ['09:30 AM','10:00 AM','10:30 AM','11:00 AM','11:30 AM','12:00 PM','12:30 PM','01:00 PM','1:30 PM','02:00 PM','2:30 PM','3:00 PM','3:30 PM']

export const weekDays = ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN']

export const getDayName = (date = new Date(), locale = 'en-US') => {
    return date.toLocaleString(locale, {weekday: 'long'});
  }
